import POINT_INVITE_ICON from 'src/features/notifications/assets/point-invite.png'
import POINT_LICENSE_ICON from 'src/features/notifications/assets/point-license.png'
import POINT_PROFILE_ICON from 'src/features/notifications/assets/point-profile.png'
import POINT_SETTING_ICON from 'src/features/notifications/assets/point-setting.png'
import POINT_STANDARD_ICON from 'src/features/notifications/assets/point-standard.png'
import POINT_WELCOME_ICON from 'src/features/notifications/assets/point-welcome.png'

export enum PointReason {
  INVITED = 'invited',
  INVITATION = 'invitation',
  FIRST_SENT_REFERRAL = 'first_sent_referral',
  SENT_REFERRAL_APPROVED = 'sent_referral_approved',
  RECEIVED_REFERRAL_APPROVED = 'received_referral_approved',
  FIRST_POINTS = 'first_points',
  LEAD_CREDIT_REWARD = 'lead_credit_reward',
  SUPPORT = 'support',
  GENERAL = 'general',
  CUSTOM = 'custom',
  FEED_ACTIVITY = 'feed_activity',
  PARTNER_MATCH = 'partner_match',
  PROFILE_COMPLETED = 'profile_completed',
}

const POINT_STANDARD = {
  icon: POINT_STANDARD_ICON,
  width: 36,
  height: 36,
}

const POINT_WELCOME = {
  icon: POINT_WELCOME_ICON,
  width: 30,
  height: 30,
}

const POINT_SETTING = {
  icon: POINT_SETTING_ICON,
  width: 30,
  height: 30,
}

const POINT_LICENSE = {
  icon: POINT_LICENSE_ICON,
  width: 32,
  height: 32,
}

const POINT_PROFILE = {
  icon: POINT_PROFILE_ICON,
  width: 42,
  height: 42,
}

const POINT_INVITE = {
  icon: POINT_INVITE_ICON,
  width: 30,
  height: 30,
}

const ICON_MAP = {
  [PointReason.INVITED]: POINT_INVITE,
  [PointReason.INVITATION]: POINT_INVITE,
  [PointReason.FIRST_SENT_REFERRAL]: POINT_STANDARD,
  [PointReason.SENT_REFERRAL_APPROVED]: POINT_STANDARD,
  [PointReason.RECEIVED_REFERRAL_APPROVED]: POINT_STANDARD,
  [PointReason.FIRST_POINTS]: POINT_WELCOME,
  [PointReason.LEAD_CREDIT_REWARD]: POINT_SETTING,
  [PointReason.SUPPORT]: POINT_SETTING,
  [PointReason.GENERAL]: POINT_STANDARD,
  [PointReason.CUSTOM]: POINT_LICENSE,
  [PointReason.FEED_ACTIVITY]: POINT_PROFILE,
  [PointReason.PARTNER_MATCH]: POINT_PROFILE,
  [PointReason.PROFILE_COMPLETED]: POINT_PROFILE,
}

const PointIcon = ({ reason }: { reason: PointReason | null }) => {
  if (!reason) {
    return (
      <div className="relative flex size-[49px] items-center justify-center rounded-[10px] border-2 border-white bg-background shadow-[0_2px_12px_rgba(27,48,41,0.1)]">
        <img src={POINT_STANDARD_ICON} alt="point standard icon" className="size-[36px] object-contain" />
      </div>
    )
  }

  const { icon, width, height } = ICON_MAP[reason]

  return (
    <div className="relative flex size-[49px] items-center justify-center rounded-[10px] border-2 border-white bg-background shadow-[0_2px_12px_rgba(27,48,41,0.1)]">
      <img src={icon} alt="point icon" className="object-contain" style={{ width, height }} />
    </div>
  )
}

export default PointIcon
